import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

const ServiceCard = ({ service }) => {
  const { slug, frontmatter } = service

  return (
    <div className="column is-12-mobile is-6-tablet is-4-desktop">
      <Link to={slug} className="card-link-wrapper">
        <div className="card service-card hover-lift">
          {/* Featured Image */}
          {frontmatter.featuredImage && (
            <div className="card-image service-card-image">
              <figure className="image is-16by9">
                <img
                  src={frontmatter.featuredImage}
                  alt={frontmatter.title}
                  style={{ objectFit: 'cover' }}
                />
              </figure>
            </div>
          )}

          <div className="card-content">
            {/* Icon and Featured Badge */}
            <div className="mb-3 is-flex is-justify-content-space-between is-align-items-center">
              <span className="icon is-large has-text-primary" style={{ fontSize: '2.5rem' }}>
                <i className={`fas ${frontmatter.icon}`}></i>
              </span>
              {frontmatter.featured && (
                <span className="tag is-warning is-light">
                  <span className="icon is-small">
                    <i className="fas fa-star"></i>
                  </span>
                  <span>Featured</span>
                </span>
              )}
            </div>

            {/* Title */}
            <h3 className="title is-4 service-card-title mb-3">
              {frontmatter.title}
            </h3>

            {/* Short Description */}
            <p className="service-card-description is-size-6 mb-4">
              {frontmatter.shortDescription}
            </p>

            {/* Features Preview (first 3) */}
            {frontmatter.features && frontmatter.features.length > 0 && (
              <div className="content mb-4">
                <ul className="service-card-features">
                  {frontmatter.features.slice(0, 3).map((feature, index) => (
                    <li key={index} className="is-size-7">
                      <span className="icon-text">
                        <span className="icon is-small has-text-success">
                          <i className="fas fa-check"></i>
                        </span>
                        <span>{feature.text}</span>
                      </span>
                    </li>
                  ))}
                  {frontmatter.features.length > 3 && (
                    <li className="is-size-7 has-text-grey-light">
                      And {frontmatter.features.length - 3} more...
                    </li>
                  )}
                </ul>
              </div>
            )}

            {/* Learn More Link */}
            <div className="has-text-centered mt-4">
              <span className="button is-primary is-outlined is-small is-rounded">
                <span>Learn More</span>
                <span className="icon is-small">
                  <i className="fas fa-arrow-right"></i>
                </span>
              </span>
            </div>
          </div>
        </div>
      </Link>
    </div>
  )
}

ServiceCard.propTypes = {
  service: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    frontmatter: PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      shortDescription: PropTypes.string,
      featuredImage: PropTypes.string,
      features: PropTypes.arrayOf(
        PropTypes.shape({
          text: PropTypes.string,
        })
      ),
      featured: PropTypes.bool,
    }).isRequired,
  }).isRequired,
}

export default ServiceCard
